<template>
  <Modal id="add-new-token" :title="title" class="create-token-form" @submit="submit">
    <template v-slot:body>
      <div class="position-relative row general">
        <div class="col-6 col-xl-4 mt-2 mb-2" v-for="(object, key) in platforms" :key="key">
          <input type="radio" :value="key" v-model="platform" />
          <div :class="`card modal-item ${key}`">
            <img :src="`/assets/images/${object.logo}`" />
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      platform: ''
    }
  },
  computed: {
    title() {
      return 'Create Token'
    },
    action() {
      return 'create'
    },
    submitUri() {
      return `token/create`
    },
    data() {
      return {
        platform: this.platform
      }
    },
    platforms() {
      let platforms = {}
      for (const [key, object] of Object.entries(Object.assign({}, this.$util.options.platforms))) {
        if (object.relation_token && object.enabled) {
          platforms[key] = object
        }
      }
      return platforms
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    submit() {
      if (this.platform != '') {
        this.submitForm(this.data, {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.$emitter.emit('Modal', {
                name: 'token.edit',
                data: {
                  _id: response.id,
                  _platform: this.platform
                },
                $el: this.$el
              })
            }
          }
        })
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.create-token-form.modal {
  .modal-body {
    .modal-item {
      border: 3px solid transparent;
      height: 100%;
      justify-content: center;
    }
    input[type='radio'] {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      cursor: pointer;
      &:checked ~ div {
        border: 3px solid #00a6ff;
      }
    }
  }
}
</style>
